import styled from '@emotion/styled';

import { colors } from '../../../styles/colors';
import { MediaBP as MQ } from '../../../styles/mediaQuery';
import { skeletonLoading } from '../../../styles/styles';

export const Container = styled.div`
  margin-top: 190px;
  width: 100%;
  padding: 0px 16px;
  &::before {
    content: '';
    border-radius: 6px;
    background-color: ${colors.TemplateLoaderTrayBgDesktop};
    width: 100%;
    height: 120px;
    display: block;
    margin-bottom: 13px;
    margin-top: 24px;
    ${MQ.MediaSm} {
      height: 120px;
    }
  }
  ${MQ.MediaSm} {
    padding: 0px;
    margin-top: 210px;
  }
  position: relative;
  ${skeletonLoading}
`;
